import insecurityInsightAboutLogo from '../static/logos/insecurity-insight-logo-bw.webp';
import shccAboutLogo from '../static/logos/shcc-logo-bw.webp';
import mapactionAboutLogo from '../static/logos/mapaction-logo-bw.webp';
import jhLogo from '../static/logos/JHSPHLogo.webp';
import dornsifeLogo from '../static/logos/Dornsife.webp';
import icnLogo from '../static/logos/ICNlogo.webp';
import phrLogo from '../static/logos/phr_logo.webp';
import intrahealthLogo from '../static/logos/Intrahealth.webp';
import edaLogo from '../static/logos/eda_logo.webp';
import ukAidLogo from '../static/logos/uk_aid_logo.webp';
import gffoLogo from '../static/logos/gffo_logo.webp';
import riahLogo from '../static/logos/riah_logo.webp';
import h2hLogo from '../static/logos/h2h_full_logo.webp';

export const logos = {
    mainLogos: [
        {
            logo: insecurityInsightAboutLogo,
            link: 'http://insecurityinsight.org/',
            alt: 'Insecurity Insight logo',
        },
        {
            logo: shccAboutLogo,
            link: 'https://safeguarding-health.com/',
            alt: 'SHCC logo',
        },
    ],
    mapactionLogos: [
        {
            logo: mapactionAboutLogo,
            link: 'https://mapaction.org/',
            alt: 'MapAction logo',
        },
    ],
    collaborationLogos: [
        {
            logo: jhLogo,
            link: 'https://www.jhsph.edu/',
            alt: 'Johns Hopkins logo',
        },
        {
            logo: dornsifeLogo,
            link: 'https://drexel.edu/dornsife/',
            alt: 'Dornsige logo',
        },
        {
            logo: icnLogo,
            link: 'https://www.icn.ch/',
            alt: 'ICN logo',
        },
        {
            logo: phrLogo,
            link: 'https://phr.org/',
            alt: 'PHR logo',
        },
        {
            logo: intrahealthLogo,
            link: 'https://www.intrahealth.org/',
            alt: 'Intra Health logo',
        },
    ],
    fundingLogos: [
        {
            logo: edaLogo,
            link: 'https://www.dfae.admin.ch/fr/',
            alt: 'EDA logo',
        },
        {
            logo: riahLogo,
            link: 'https://riah.manchester.ac.uk/',
            alt: 'RIAH logo',
        },
        {
            logo: ukAidLogo,
            link: 'https://www.ukaiddirect.org/',
            alt: 'UKAid logo',
        },
        {
            logo: gffoLogo,
            link: 'https://www.deutschland.de/en/humanitarian-assistance',
            alt: 'GFFO logo',
        },
        {
            logo: h2hLogo,
            link: 'https://h2hnetwork.org/',
            alt: 'H2H logo',
        },
    ],
};
